"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks if a slate document is devoid of content.
 * Returns true if the document does not contain
 * any content within any of its blocks.
 *
 * @param value    The slate value to check.
 * @param textOnly Ignore non text blocks.
 */
function isEmpty(value, textOnly) {
    if (textOnly === void 0) { textOnly = false; }
    if (!value) {
        return true;
    }
    var document;
    // Deserialize the document if it's a string
    if (typeof value === 'string') {
        document = JSON.parse(value);
    }
    else {
        document = value;
    }
    // Temporary fix for double string encoded card summaries
    if (typeof document === 'string') {
        document = JSON.parse(document);
    }
    if (!document || !document.length) {
        return true;
    }
    var hasContent = false;
    var singleLevelBlocks = [
        'paragraph',
        'code',
        'block-quote',
        'heading-one',
        'heading-two',
    ];
    var twoLevelBlocks = ['numbered-list', 'bulleted-list'];
    var nonTextBlocks = [
        'media',
        'embed-media',
        'insert-image-upload',
        'image-uploaded',
        'image-linked',
        'insert-image-phone',
    ];
    document.forEach(function (block) {
        if (!textOnly && nonTextBlocks.includes(block.type)) {
            // If textOnly is false, images are considered valid content
            hasContent = true;
        }
        else if (singleLevelBlocks.includes(block.type)) {
            // Single level blocks have text nodes as their children
            if (block.children && block.children.length) {
                block.children.forEach(function (child) {
                    if (child.text) {
                        hasContent = true;
                    }
                });
            }
        }
        else if (twoLevelBlocks.includes(block.type)) {
            if (block.children && block.children.length) {
                // Two level blocks have blocks as their children
                block.children.forEach(function (child) {
                    if (child.children && child.children.length) {
                        child.children.forEach(function (grandchild) {
                            if (grandchild.text) {
                                hasContent = true;
                            }
                        });
                    }
                });
            }
        }
    });
    return !hasContent;
}
exports.default = isEmpty;
//# sourceMappingURL=isEmpty.js.map